import type { FaireProductEntity } from "../../entity_types/product";

export const p_uew9399zpe: FaireProductEntity = {
  token: "p_uew9399zpe",
  type: "product",
  name: "Industrial-Style Weathered Zinc Metal Board with Stand",
  brandName: "Factory Direct Craft",
  imageUrl:
    "https://cdn.faire.com/fastly/dd567a87e7d28c480bb29c3439f0f9c654a3230b030ea7629cae2a3fdbf39e9f.jpeg",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2707b01c2dc25c36cd8a95477ce388bf7200c928eb0890ef04d25417038a9b58.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
